import { DNDLayout } from './DNDLayout';
import { withDndHtmlContext, withDndTouchContext } from './dnd-service';

export const DesktopDNDLayout = withDndHtmlContext(DNDLayout);

export const MobileDNDLayout = withDndTouchContext(DNDLayout);
